import React from 'react';
import Add from './add';
import $ from "jquery";
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import Loading from '../../loading';
import Edit from './edit';
import { Image, Grid, Button } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Images from './image';
import Viewcustomertype from './customertype';

class View extends React.Component {

  state={
    deleteDialog: false,
    maxWidth: 'sm',
    fullWidth: true,
  }

  handleClose = () => {
    this.setState({ editDialog: false, deleteDialog: false });
  };

  success() {
    this.setState({ editDialog: false });
    this.props.getOffers();
  }

  delete() {
    let context = this;
    context.setState({
      load: true,
      message: 'Delete Offers Details'
    });
    let data1 = { 'id': this.state.deleteId }
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'offer/delete.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        if (data == 1) {
          context.setState({
            deleteDialog: false,
          });
          context.props.getOffers();
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }


  render() {
    return (
      <div><br/>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={13}>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={3}>
                  {
                    this.props.menuPermission.add ?
                    <Add getOffers={this.props.getOffers} offeredit={this.props.offeredit} />:''
                  }
                  
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                <table width='100%' id='table' style={{display: this.props.offerview}}>
                  <tr>
                    <th id='tableheader' style={{ width: '7%' }}><center>sino</center></th>
                    <th id='tableheader' style={{ width: '15%' }}><center>Title</center></th>
                    <th id='tableheader' style={{ width: '15%' }}><center>Description</center></th>
                    <th id='tableheader' style={{ width: '10%' }}><center>Image</center></th>
                    <th id='tableheader' style={{ width: '13%' }}><center>Date</center></th>
                    <th id='tableheader' style={{ width: '10%' }}><center>Customer Type</center></th>
                    <th id='tableheader' style={{ width: '11%' }}><center>Combos</center></th>
                    { this.props.menuPermission.edit ?
                      <th id='tableheader' style={{ width: '7%'}}><center>Edit</center></th>:
                      ''
                    }
                    { this.props.menuPermission.cancel ?
                      <th id='tableheader' style={{ width: '7%' }}><center>Delete</center></th>:
                      ''
                    }
                    
                    
                  </tr>
                  { this.props.offer.map((z) => {
                      let start = z.start_date;
                      let end = z.end_date;
                      start = start.split(" ")[0];
                      end = end.split(" ")[0];
                      return (
                        <tr>
                          <td><center>{z.sino}</center></td>
                          <td><center>{z.title}</center></td>
                          <td><center>{z.offer}</center></td>
                          <td>
                            <center>
                              <Images menuPermission={this.props.menuPermission} id={z.id} image={z.image} offeredit={this.props.offeredit} />
                            </center>
                          </td>
                          <td>
                            <center>
                            {start}<br/>
                            <b>to</b><br/>
                            {end}
                            </center>
                          </td>
                          <td><center><Viewcustomertype menuPermission={this.props.menuPermission} data={this.props.offer} id={z.id} viewEdit={this.props.viewEdit} /></center></td>
                          <td><center>{z.combo_name}</center></td>
                          { this.props.menuPermission.edit ?
                            <td style={{cursor: 'pointer'}}
                                onClick={ () => { this.setState({ editDialog: true, editId: z.id }) }}>
                              <center>Edit</center>
                            </td>:
                            ''
                          }
                          
                          { this.props.menuPermission.cancel ?
                            <td style={{cursor: 'pointer'}}
                                onClick={ () => { this.setState({ deleteDialog: true, deleteId: z.id }) } }>
                              <center>Delete</center>
                            </td>:
                            ''
                          }
                          
                        </tr>
                      );
                    })
                  }
                </table>
                </Grid.Column>
              </Grid>
        <div><br/>

          <Edit offer={this.props.offer} success={this.success.bind(this)}
                editDialog={this.state.editDialog} editId={this.state.editId}
                handleClose={this.handleClose} />
        </div>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.deleteDialog}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Delete Offer</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    Do you want to remove it!!!
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button fluid onClick={ () => { this.setState({ deleteDialog: false }) }}>Cancel</Button>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button fluid onClick={this.delete.bind(this)}>Delete</Button>
                  </Grid.Column>
                </Grid>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default View;
